interface IHotelTranslationTypes {
  hotel: string;
  activity: string;
  camp: string;
}

export const HotelTranslationTypes: IHotelTranslationTypes = {
  hotel: "hotel",
  activity: "activity",
  camp: "camp",
};
